import { __rest } from 'tslib';
import React__default from 'react';
import { SvgIcon } from '../components/svgIcon/svgIcon.js';

const SvgIcon24 = (_a) => {
    var { viewbox = '0 0 24 24' } = _a, others = __rest(_a, ["viewbox"]);
    return React__default.createElement(SvgIcon, Object.assign({ viewbox: viewbox }, others));
};

export { SvgIcon24 };
